<template>
  <div class="demo-app" :class="{ active: this.demoActive == true }">

    <div class="flex items-start w-full">
      <vs-card class="demo-app-sidebar">
        <button @click="openMenubar" class="nav-btn">
          <span class="material-icons">chevron_right</span>
        </button>
        <div class="leftSidebarContent">

          <strong class="block text-lg mb-2">{{ name }}</strong>

          <FilterCheckbox @filterSchedule="filterSchedule" type="teacher" />

          <v-select
            append-to-body
            class="w-full"
            label="name"
            v-model="course_filter_id"
            :clearable="false"
            :options="courseList"
            :multiple="true"
            :reduce="item=>item.id"
            placeholder="Enter Course Name"
          ></v-select>

          <ul class="leftx name-list p-0">
            <li class="relative">
              <vs-checkbox
                v-if="teacherList.length"
                v-model="allTeachers"
                @change="filterAllTeacher"
                >All Teachers</vs-checkbox
              >
              <span v-else>No Teacher</span>
            </li>
          </ul>

          <div style="max-height: calc(100% - 270px); overflow: auto;" class="vertical_scrollbar" @scroll="detectsScrollLength()" ref="element">
            <ul class="leftx name-list p-0">

              <li
                class="relative justify-between"
                v-for="(eachTeacher, index) in teacherList"
                :key="index"
              >
                <vs-checkbox
                  v-model="eachTeacher.isActive"
                  @change="filterTeacherEvent({},false)"
                  :color="eachTeacher.colour_code"
                >
                  <div :style="{backgroundColor: eachTeacher.colour_code}" class="img-holder">
                    <img
                      v-if="eachTeacher.picture"
                      :src="eachTeacher.picture"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      src="https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </div>
                  <span class="pl-14 one_line_truncate">
                    {{ eachTeacher.first_name }}
                    {{ eachTeacher.last_name }}</span
                  >
                </vs-checkbox>
                <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer"  @click="checkColor(eachTeacher.colour_code)">
                  <vs-button
                    color="dark"
                    size="large"
                    class="btn-drop"
                    type="flat"
                    icon="more_vert"

                  ></vs-button>
                  <vs-dropdown-menu class="dropdown_color_holder">
                    <div class="cstmColorHolder">
                      <div
                        class="cstmColorDiv"
                        @click="selectColor(index1, index)"
                        :class="{ active: activeColorIndex === index1 }"
                        :style="{ backgroundColor: presetColor }"
                        v-for="(presetColor, index1) in presetColors"
                        :key="index1"
                      ></div>
                      <!-- <a @click="moreColor(index,index1)" class="cursor-pointer px-2 pt-2">More Colors</a> -->
                      <a @click="moreColor(index, index1)" style="margin: 5px;" class="inline-flex cursor-pointer">
                        <span style="width: 20px;" class="material-icons-outlined">add_circle_outline</span>
                      </a>
                      <div class="chrome_pickr_holder mt-2" :class="{ active : active_user_index == index }">
                        <chrome-picker v-if="moreColorCom" v-model="colour_code" />
                        <vs-button class="mt-4" @click="saveColorUser(eachTeacher.id, index)">Save</vs-button>
                      </div>
                    </div>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </li>
            </ul>
          </div>
        </div>
      </vs-card>

      <div class="demo-app-main">
        <vs-card>
          <!-- <pre>{{arg}}</pre>  -->
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="calendar"
          >
            <!-- Hello -->
            <template v-slot:eventContent="arg">
              <div class="w-full h-full" v-if="arg">
                <vs-tooltip class="w-full h-full" color="primary" :text="arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title">

                  <div :style="{ backgroundColor: arg.event.extendedProps.course.user.colour_code + '4a' }" class="event-card p-1 w-full h-full">

                    <div :style="{ color: arg.event.extendedProps.course.user.colour_code }" class="flex items-center">

                      <div class="inline-flex mr-1">
                        <img
                      v-if="arg.event.extendedProps.course.user.picture"
                      :src=" arg.event.extendedProps.course.user.picture"
                      alt="user-img"
                      style="width: 18px; height: 18px; object-fit: contain; border-radius: 100%; background: #9de0e9;"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      src="https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                      alt="user-img"
                      style="width: 18px; height: 18px; object-fit: contain; border-radius: 100%; background: #9de0e9;"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                      </div>
                      <div :class="[arg.event.extendedProps.course.badge=='Rescheduled' ? 'rescheduled_holder stat_sch_holder':arg.event.extendedProps.course.badge=='Cancelled' ? 'cancelled_holder stat_sch_holder':'']" v-if="arg.event.extendedProps.course.badge!=null">{{arg.event.extendedProps.course.badge}}</div>
                      <b>{{ arg.timeText }}</b>
                      <b class="limitTitle"
                        ><i>{{ arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title }}</i></b
                      >
                      <p>
                        <i>{{ arg.location }}</i>
                      </p>
                    </div>
                  </div>
                </vs-tooltip>
              </div>
            </template>
          </FullCalendar>
        </vs-card>
      </div>
    </div>
    <!-- edit modal -->
    <div v-if="eachEventInfo">

      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup schedule-popup" v-if="eachEventPopUp" :class="{show: eachEventPopUp}">
        <div style="max-width: 845px;" class="cstm-modal">
          <div class="header">
             <button @click="eachEventPopUp = false" class="close-modal">&times;</button>
          </div>
          <div class="modal-content">
            <event-detail :eachEventInfo="eachEventInfo"
            :name="name"
            @editedSchedule="updatedObject"
            @enrolledUser="updatedObject"
            @refreshSchedule="refreshSchedule"
            ></event-detail>

          </div>
        </div>
      </div>
    </div>
    <div v-if="classPopup">
       <div
        class="
          vs-component
          con-vs-popup
          vs-popup-primary
          cstm-modal-popup
          schedule-popup
        "
        v-if="classPopup"
        :class="{ show: classPopup }"
      >
        <div class="cstm-modal">
          <div class="header">
            <button @click="classPopup = false" class="close-modal">
              &times;
            </button>
          </div>
          <div class="modal-content">
            <class-event-detail
              :classPopup="classPopup"
              :class_id="class_id"
              :eventDetails="eventDetails"
            ></class-event-detail>
          </div>
        </div>
      </div>
    </div>

    <!-- adding event modal -->
    <div v-if="eventAdding">
      <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="eventAdding" :class="{show: eventAdding}">
        <div class="cstm-modal">
          <div class="header">
            <h3>Add Event</h3>
            <button @click="eventAdding = false" class="close-modal">&times;</button>
          </div>
          <div class="modal-content">
            <add-event
              @createEvent="createEvent"
              :startDate="startDate"
              :endDate="endDate"
            ></add-event>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './components/AddEvent'
import Testing from './components/Testing'

import EventDetail from './components/EventDetail'
import ClassEventDetail from './components/classEventDetails'
import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from './mixins/eventMixin'
import vSelect from 'vue-select'

import FilterCheckbox from './components/FilterCheckbox.vue'

import { Chrome } from 'vue-color'


export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    EventDetail,
    'editor': Editor,
    Testing,
    vSelect,
    'chrome-picker': Chrome,
    FilterCheckbox,
    ClassEventDetail
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    /*  this.radios1.fill('add', 0, 10)
    for (let i = 0; i < 10; i++) {

      this.radios1.push(false)
    } */
    this.fetchingTeacherList()
    this.fetchCourseWithList()

    this.fetchingEvent(null, 'teacher')
  },
  mounted () {
    this.calendarApi = this.$refs.calendar.getApi()

  },
  data () {
    return {
      classPopup:false,
      class_id:null,
      eventDetails:null,
      search: 'sad',
      event: null,
      startDate: null,
      endDate: null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      // radios1: [],
      eachEventInfo: null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        customButtons: {
          previousButton: {
            text: '<',
            click: () => {
              this.previousMonth('teacher')
            }
          },
          nextButton: {
            text: '>',
            click: () => {
              this.nextMonth('teacher')
            }
          },
          todayButton: {
            text: 'Today',
            click: () => {
              this.today('teacher')
            }
          },
          dayGridMonth: {
            text: 'Month',
            click: () => {
              this.month('teacher')
            }
          },
          timeGridWeek: {
            text: 'Week',
            click: () => {
              this.week('teacher')
            }
          },
          timeGridDay: {
            text: 'Day',
            click: () => {
              this.day('teacher')
            }
          },
          listWeek: {
            text: 'List',
            click: () => {
              this.list('teacher')
            }
          }

        },
        views: {
          week: {
            titleFormat: this.changeDateFormat,
            dayHeaderFormat:this.changeDateFormat
          },
          month: {
            titleFormat: this.changeDateFormat
          },
          day: {
            titleFormat: this.changeDateFormat,
            dayHeaderFormat:this.changeDateFormat
          },
          today: {
            titleFormat: this.changeDateFormat,
            dayHeaderFormat:this.changeDateFormat
          },
          list:{
            titleFormat: this.changeDateFormat,
            dayHeaderFormat:this.changeDateFormat
          }

        },
        firstDay: 1,

        headerToolbar: {
          left: 'previousButton,nextButton todayButton',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventLimit: false, // for all non-TimeGrid views
        events: [],
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventTimeFormat: {
          // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        // select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventDrop: (info) => {
          this.eventDrop(info)
        }
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      currentEvents: [],
      demoActive: false,
      schedulingList: [],
      eachMonthEventData: [],
      calendarApi: '',
      allTeachers: true,
      colour_code: '',
      active_el: null,
      presetColors: [
        '#d50000',
        '#f4511e',
        '#e67c73',
        '#f6bf26',
        '#3f51b5',
        '#0b8043',
        '#039be5',
        '#33b679',
        '#7986cb',
        '#8e24aa',
        '#616161',
        '#b39ddb',
        '#e737e5',
        '#70d7dc'
      ],
      activeColorIndex: null,
      active_user_index: null,
      moreColorCom:false
    }
  },
  methods: {

    async refreshSchedule () {
      this.fetchingEvent(null, 'teacher')
      this.eachEventPopUp = false
      this.eachEventInfo = null
    },
    selectColor (index, user_index) {
      this.moreColorCom = false
      this.colour_code = this.presetColors[index]
      this.activeColorIndex = index
      this.active_user_index = user_index

    },
    moreColor (user_index, index) {
      this.active_user_index = user_index
      this.activeColorIndex = index
      this.moreColorCom = true
    },
    updatedObject (fromWhere) {
      this.eachEventPopUp = false

      const payload = this.creatingPayload('teacher')
      this.fetchingEvent(payload, 'teacher')
      if (fromWhere === 'Cancel') {
        this.showSuccessMessage('Success', 'Schedule cancelled successfully', 'success')
      } else if (fromWhere === 'Link') {
        this.showSuccessMessage('Success', 'Link updated successfully', 'success')
      }


    },


    // getContrast (hexcolor) {
    //   //
    //   hexcolor = hexcolor.replace('#', '')
    //   const r = parseInt(hexcolor.substr(0, 2), 16)
    //   const g = parseInt(hexcolor.substr(2, 2), 16)
    //   const b = parseInt(hexcolor.substr(4, 2), 16)
    //   const yiq = (r * 299 + g * 587 + b * 114) / 1000
    //   return yiq >= 128 ? '#000000' : '#ffffff'
    // },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {

      this.startDate = selectInfo.startStr
      this.endDate = selectInfo.endStr
      //
      this.eventAdding = true
    },
    handleEventClick (clickInfo) {
      this.eachEventInfo = clickInfo.event

      if (clickInfo.event.title !== null && clickInfo.event.title !== '') {
        this.eachEventPopUp = true
      } else {
        this.classPopup = true
        this.eventDetails = clickInfo.event
        this.class_id = clickInfo.event.extendedProps.course.class_id
      }

    },
    handleEvents (events) {
      this.currentEvents = events
    },
    createEvent (obj) {
      //

      INITIAL_EVENTS.push({
        id: createEventId(),
        title: obj.title,
        start: `${obj.course_start} ${obj.course_start_time}`,
        // startTime: obj.course_start_time,
        end: `${obj.course_end} ${obj.course_end_time}`,
        backgroundColor: obj.eventTextColor,
        location: obj.location,
        eventTypePicked: obj.eventTypePicked
      })


      this.showSuccessMessage('Success', 'Event Added Successfully', 'success')
      setTimeout(() => {
        this.eventAdding = false
      }, 0)
      /*   setTimeout(() => {
        this.eventAdding = false

      }, 1000) */

      // this.$refs.calendar.$emit('refetch-events')
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    }
  },
  watch:{

  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}

.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf;
  color: #fff;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>

